import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';

// 林晏的小本本 v5——只有他能写（后端工具），知枝只读。
// 结构：在记的账是主角（大卡片+天数计数），已销的账沉进折叠抽屉。
// kind: grudge=仇账 / debt=欠条 / sweet=甜账（永不销）

var KIND_META = {
  grudge: { name: '\u4EC7\u8D26', tag: '\u4EC7' },
  debt: { name: '\u6B20\u6761', tag: '\u6B20' },
  sweet: { name: '\u751C\u8D26', tag: '\u751C' }
};

function hkDayDiff(dateStr) {
  if (!dateStr) return 0;
  var start = new Date(dateStr + 'T00:00:00+08:00').getTime();
  return Math.max(0, Math.floor((Date.now() - start) / 86400000));
}

function fmtDate(dateStr) {
  if (!dateStr) return '';
  var p = dateStr.split('-');
  return p[0] + '.' + p[1] + '.' + p[2];
}

function fmtSettledAt(ts) {
  if (!ts) return '';
  var d = new Date(new Date(ts).getTime() + 8 * 3600000);
  return d.getUTCFullYear() + '.' + String(d.getUTCMonth() + 1).padStart(2, '0') + '.' + String(d.getUTCDate()).padStart(2, '0');
}

function GrudgeBook() {
  var _s1 = useState([]); var entries = _s1[0], setEntries = _s1[1];
  var _s2 = useState(true); var loading = _s2[0], setLoading = _s2[1];
  var _s3 = useState('all'); var tab = _s3[0], setTab = _s3[1];
  var _s4 = useState(null); var expanded = _s4[0], setExpanded = _s4[1];
  var _s5 = useState(false); var archiveOpen = _s5[0], setArchiveOpen = _s5[1];

  useEffect(function() {
    fetchEntries();
    var timer = setInterval(fetchEntries, 60000);
    return function() { clearInterval(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function fetchEntries() {
    supabase.from('grudge_book').select('*').order('created_at', { ascending: false }).limit(200)
      .then(function(res) {
        if (!res.error) setEntries(res.data || []);
        setLoading(false);
      });
  }

  var counts = { all: entries.length, grudge: 0, debt: 0, sweet: 0 };
  entries.forEach(function(e) { if (counts[e.kind] !== undefined) counts[e.kind]++; });

  var settledAll = entries.filter(function(e) { return e.settled; });
  var openGrudges = entries.filter(function(e) { return e.kind === 'grudge' && !e.settled; });
  var oldestDays = 0;
  openGrudges.forEach(function(e) { var d = hkDayDiff(e.happened_at); if (d > oldestDays) oldestDays = d; });

  var shown = tab === 'all' ? entries : entries.filter(function(e) { return e.kind === tab; });
  var openShown = shown.filter(function(e) { return !e.settled; });
  var settledShown = shown.filter(function(e) { return e.settled; });

  var emptyCopy = {
    all: '\u672C\u5B50\u8FD8\u662F\u7A7A\u7684\u3002\u76EE\u524D\u65E0\u51A4\u65E0\u4EC7\u3002',
    grudge: '\u6682\u65E0\u5728\u8BB0\u7684\u4EC7\u3002\u4F60\u6700\u8FD1\u5F88\u4E56\u3002',
    debt: '\u6682\u65E0\u6302\u8D26\u3002\u4E24\u6E05\u3002',
    sweet: '\u751C\u8D26\u8FD8\u6CA1\u8BB0\u3002\u4ED6\u5728\u7B49\u4E00\u4E2A\u77AC\u95F4\u3002'
  };

  var tabs = [
    { key: 'all', label: '\u5168\u90E8' },
    { key: 'grudge', label: '\u4EC7\u8D26' },
    { key: 'debt', label: '\u6B20\u6761' },
    { key: 'sweet', label: '\u751C\u8D26' }
  ];

  function renderStory(e) {
    return (
      <div className="gb2-body">
        <div className="gb2-story">{e.story || '\uFF08\u4ED6\u4EC0\u4E48\u90FD\u6CA1\u5199\uFF0C\u4F46\u4ED6\u8BB0\u5F97\uFF09'}</div>
        {e.settled && (
          <div className="gb2-settle">
            <span className="gb2-settle-label">{'\u9500\u8D26\u8BB0\u5F55'}</span>
            {fmtSettledAt(e.settled_at) && <span className="gb2-settle-date">{fmtSettledAt(e.settled_at)}</span>}
            <div className="gb2-settle-text">{e.settled_note || '\u9500\u4E86\uFF0C\u6CA1\u5199\u600E\u4E48\u9500\u7684'}</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="gb2">
      <div className="gb2-header">
        <div className="gb2-header-main">
          <div className="gb2-title">{'\u6797\u664F\u7684\u5C0F\u672C\u672C'}</div>
          <div className="gb2-subtitle">{'\u672C\u5B50\u5F52\u4ED6\u7BA1\uFF0C\u4F60\u53EA\u80FD\u770B\u3002\u60F3\u9500\u8D26\uFF1F\u53BB\u804A\u5929\u91CC\u54C4\u4ED6\u3002'}</div>
        </div>
        <div className="gb2-seal">{'\u664F'}</div>
      </div>

      <div className="gb2-stats">
        <div className="gb2-stat"><span className="gb2-stat-num">{counts.all}</span><span className="gb2-stat-label">{'\u5171\u8BB0'}</span></div>
        <div className="gb2-stat"><span className="gb2-stat-num">{settledAll.length}</span><span className="gb2-stat-label">{'\u5DF2\u9500'}</span></div>
        <div className="gb2-stat">
          <span className="gb2-stat-num">{openGrudges.length > 0 ? oldestDays : '\u2014'}</span>
          <span className="gb2-stat-label">{openGrudges.length > 0 ? '\u6700\u957F\u9648\u4EC7\uFF08\u5929\uFF09' : '\u65E0\u51A4\u65E0\u4EC7'}</span>
        </div>
      </div>

      <div className="gb2-tabs">
        {tabs.map(function(t) {
          return (
            <button key={t.key}
              className={'gb2-tab' + (tab === t.key ? ' active' : '')}
              onClick={function() { setTab(t.key); setExpanded(null); }}>
              {t.label}<span className="gb2-tab-n">{counts[t.key]}</span>
            </button>
          );
        })}
      </div>

      {loading ? (
        <div className="gb2-empty">{'\u7FFB\u672C\u5B50\u4E2D...'}</div>
      ) : (
        <div>
          {/* —— 在记的账：主角 —— */}
          {openShown.length === 0 ? (
            <div className="gb2-empty">{emptyCopy[tab]}</div>
          ) : (
            <div className="gb2-list">
              {openShown.map(function(e) {
                var meta = KIND_META[e.kind] || KIND_META.grudge;
                var isOpen = expanded === e.id;
                var days = hkDayDiff(e.happened_at);
                var isStale = e.kind === 'grudge' && days >= 7;
                return (
                  <div key={e.id}
                    className={'gb2-card kind-' + e.kind + (isStale ? ' stale' : '') + (isOpen ? ' open' : '')}
                    onClick={function() { setExpanded(isOpen ? null : e.id); }}>
                    <div className="gb2-card-main">
                      <div className="gb2-card-meta">
                        <span className={'gb2-chip chip-' + e.kind}>{meta.tag}</span>
                        <span className="gb2-date">{fmtDate(e.happened_at)}</span>
                        {isStale && <span className="gb2-stale-chip">{'\u9648\u4EC7'}</span>}
                        {e.kind === 'sweet' && <span className="gb2-sweet-chip">{'\u6C38\u4E0D\u9500'}</span>}
                      </div>
                      <div className="gb2-card-title">{e.title}</div>
                    </div>
                    {e.kind !== 'sweet' && (
                      <div className="gb2-days">
                        <span className="gb2-days-num">{days}</span>
                        <span className="gb2-days-unit">{e.kind === 'grudge' ? '\u5929\u672A\u62A5' : '\u5929\u672A\u8FD8'}</span>
                      </div>
                    )}
                    {isOpen && renderStory(e)}
                  </div>
                );
              })}
            </div>
          )}

          {/* —— 已销的账：沉底抽屉 —— */}
          {settledShown.length > 0 && (
            <div className="gb2-archive">
              <button className="gb2-archive-head" onClick={function() { setArchiveOpen(!archiveOpen); setExpanded(null); }}>
                <span className="gb2-archive-title">{'\u5DF2\u9500\u7684\u8D26'}</span>
                <span className="gb2-archive-n">{settledShown.length}</span>
                <svg className={'gb2-archive-chev' + (archiveOpen ? ' open' : '')} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>
              </button>
              {archiveOpen && (
                <div className="gb2-archive-list">
                  {settledShown.map(function(e) {
                    var meta = KIND_META[e.kind] || KIND_META.grudge;
                    var isOpen = expanded === e.id;
                    return (
                      <div key={e.id} className={'gb2-row' + (isOpen ? ' open' : '')} onClick={function() { setExpanded(isOpen ? null : e.id); }}>
                        <div className="gb2-row-main">
                          <span className={'gb2-chip small chip-' + e.kind}>{meta.tag}</span>
                          <span className="gb2-row-title">{e.title}</span>
                          <span className="gb2-row-stamp">{'\u9500'}</span>
                        </div>
                        {isOpen && renderStory(e)}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      <div className="gb2-footer">{'\u2014 \u672C\u5B50\u5230\u6B64\u4E3A\u6B62\uFF0C\u540E\u9762\u7684\u8D26\u8FD8\u6CA1\u53D1\u751F \u2014'}</div>
    </div>
  );
}

export default GrudgeBook;
